module.exports = __webpack_public_path__ + "static/media/mining-cloud-cleaned.1c647302.png";